export const giCommissionReconciliationEndpoints = (builder) => ({
  getGICommissionReconciliationList: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        agencyId,
        hideZero,
        billYear,
        billMonth,
        policyType,
        dateOfReceipt,
        showAll,
      } = args;

      const body = {
        pageNumber,
        pageSize,
      };

      if (searchTerm) body.searchTerm = searchTerm;
      if (agencyId) body.agencyId = agencyId;
      if (hideZero !== undefined) body.hideZero = hideZero;
      if (billYear) body.billYear = billYear;
      if (billMonth) body.billMonth = billMonth;
      if (policyType) body.policyType = policyType;
      if (dateOfReceipt) body.dateOfReceipt = dateOfReceipt;
      if (showAll !== undefined) body.showAll = showAll;

      return {
        url: '/GeneralInsurance/commission-reconciliation',
        method: 'POST',
        body,
      };
    },
    providesTags: ['MotorInsuranceEntry', 'HealthInsuranceEntry', 'OtherInsuranceEntry', 'GICommissionImport'],
  }),
  getGICommissionOutstandingList: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        agencyId,
        billYear,
        billMonth,
        policyType,
      } = args;

      const body = {
        pageNumber,
        pageSize,
      };

      if (searchTerm) body.searchTerm = searchTerm;
      if (agencyId) body.agencyId = agencyId;
      if (billYear) body.billYear = billYear;
      if (billMonth) body.billMonth = billMonth;
      if (policyType) body.policyType = policyType;

      return {
        url: '/GeneralInsurance/commission-outstanding',
        method: 'POST',
        body,
      };
    },
    providesTags: ['MotorInsuranceEntry', 'HealthInsuranceEntry', 'OtherInsuranceEntry', 'GICommissionImport'],
  }),
  reconcilePolicies: builder.mutation({
    query: (payload) => ({
      url: '/GeneralInsurance/commission-reconciliation/reconcile',
      method: 'POST',
      body: payload,
    }),
    invalidatesTags: ['MotorInsuranceEntry', 'HealthInsuranceEntry', 'OtherInsuranceEntry', 'GICommissionImport'],
  }),
});
